var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrap" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.type === "loading"
          ? [
              _c("div", { staticClass: "icon loading" }),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("loginning"))),
              ]),
            ]
          : _vm.type === "success"
          ? [
              _c("div", { staticClass: "icon success" }),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("login_success_2"))),
              ]),
            ]
          : _vm.type === "fail"
          ? [
              _c("div", { staticClass: "icon fail" }),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("login_fail_2"))),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm.type === "fail"
      ? _c(
          "div",
          { staticClass: "btns" },
          [
            _c(
              "Button",
              { attrs: { type: "warning" }, on: { click: _vm.reLogin } },
              [_vm._v(_vm._s(_vm.$t("try_again")) + " ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }